import React from 'react';
import { useTranslation } from 'react-i18next';

const HelpPage = () => {
    const { t, i18n } = useTranslation();

    const getVideoSrc = () => {
        switch (i18n.language.slice(0, 2)) { // Utilise les deux premiers caractères de la langue (ex. 'en' de 'en-US')
            case 'en':
                return '/backend/static/videos/create_event_EN.mp4';
            case 'de':
                return '/backend/static/videos/create_event_DE.mp4';
            case 'es':
                return '/backend/static/videos/create_event_ES.mp4';
            case 'fr':
                return '/backend/static/videos/create_event_FR.mp4';
            default:
                return '/backend/static/videos/create_event_FR.mp4'; // Fallback si aucune correspondance
        }
    };

    return (
	<div className="container mx-auto p-4">
		<h2 className="text-2xl font-bold text-center mb-4">{t('helpPage.createYourPage')}</h2>
		<div className="flex justify-center items-center">
			<video className="video-container shadow-lg" controls>
				<source src={getVideoSrc()} type="video/mp4" />
				Votre navigateur ne supporte pas la balise vidéo.
			</video>
		</div>
	</div>
    );
};

export default HelpPage;
